import * as angular from 'angular';
import destinationsRouter from './destinations.router';

import DestinationService from 'app/common/services/destination.service';
import countryService from 'app/common/services/country.service';
import slugifyService from 'app/common/services/slugify.service';
import timezoneService from 'app/common/services/timezone.service';
import destinationTreeSelect from './general-configuration/destination-tree-select.component';
import { POI_TYPES } from './destination.constants.js';

/** @constant {angular.module} */
const destinationsModule = angular
  .module('ec.opsCenter.destinations', [])
  .config(destinationsRouter)
  .service('DestinationService', DestinationService)
  .service('countryService', countryService)
  .service('slugifyService', slugifyService)
  .service('timezoneService', timezoneService)
  .component('destinationTreeSelect', destinationTreeSelect)
  .constant('POI_TYPES', POI_TYPES).name;

export default destinationsModule;



// WEBPACK FOOTER //
// ./src/app/destinations/destinations.module.ts